import { css } from "@emotion/react";
import React from "react";
import { FaSadTear } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Sad() {
    const navigate = useNavigate();
    return (
        <div
            css={css`
                padding: 8rem 0;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            `}
        >
            <FaSadTear size="6rem" />
            <h1>Not Found</h1>
            <button onClick={() => navigate(-1)}>◀ back</button>
        </div>
    );
}
